import React from 'react';
import { AlertIconSpan } from '../atoms';
import { MessageSpan } from '../atoms';
import { StickyContent } from '../atoms';
import { AlertFormDiv } from '../atoms';
import { useRootStore } from '../../App';
import { observer } from 'mobx-react-lite';

interface Props {
  children?: any;
  alert?: boolean;
  info?: boolean;
}

export const StickyMessage = observer((props: Props) => {
  // const { alert, info, children } = props;

  const root = useRootStore();
  const { failedLoadingInquiryData } = root.inquiryPageStore;
  const { state } = root.socketStore;

  if (failedLoadingInquiryData) {
    return (
      <StickyContent>
        <AlertFormDiv>
          <AlertIconSpan />
          <MessageSpan>
            エラーが発生しました。ページの再読み込みをするか、しばらく経ってから再度アクセスしてください。
          </MessageSpan>
        </AlertFormDiv>
      </StickyContent>
    );
  }
  if (!failedLoadingInquiryData && !state.isSocketConnected) {
    return (
      <StickyContent>
        <AlertFormDiv>
          <AlertIconSpan />
          <MessageSpan>ネットワークに再接続中です。</MessageSpan>
        </AlertFormDiv>
      </StickyContent>
    );
  }

  return <></>;
});
